let navigatingPath: string | null = null;

export const getNavigatingPath = () => navigatingPath;
export const setNavigatingPath = (path: string) => {
  navigatingPath = path;
};
export const clearNavigatingPath = () => {
  navigatingPath = null;
};
